import React, {ChangeEvent, KeyboardEvent, useEffect, useState} from 'react';
import {I18n} from 'react-redux-i18n';

import {withStyles, WithStyles} from '@material-ui/core';

import {useDispatch} from 'react-redux';
import {CustomInput} from '../../material-dashboard-pro-react/components';

import {validateTOTPSecret} from './action';

import style from './style';

type ValidateTOTPSecretFormProps = WithStyles<typeof style> & {
  // eslint-disable-next-line no-unused-vars
  setValidateAction?: (callback: () => void) => void;
  // eslint-disable-next-line no-unused-vars
  onSuccess?: (responseData: { [key: string]: string | number | boolean }) => void;
  isInitial?: boolean;
};

/**
 * @param setValidateAction - callback to set the action to call when the form is submitted.
 * Allows to call validation outside of this form. Optional
 * @param onSuccess - callback on successful validation. Passes successful as a param. Optional
 * @param isInitial - if true, handles validation as first-time setup. Optional
 */
function ValidateTOTPSecretForm({
  classes,
  setValidateAction = () => {},
  onSuccess = () => {},
  isInitial = false,
}: ValidateTOTPSecretFormProps) {
  const dispatch = useDispatch();

  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const validate = () => {
    validateTOTPSecret(code, isInitial, (isValid, data) => {
      if (!isValid) {
        setError(true);
      } else {
        onSuccess(data);
      }
      setError(!isValid);
    })(dispatch);
  };

  useEffect(() => {
    setValidateAction(() => validate);
  }, [code]);

  return (
    <>
      <p>
        {I18n.t('totp.setup.validate.codeInputLabel')}
      </p>
      <CustomInput
        formControlProps={{
          fullWidth: true,
        }}
        error={error}
        errorText={error ? I18n.t('totp.setup.validate.invalidCode') : ''}
        inputProps={{
          placeholder: I18n.t('totp.setup.validate.codeInputPlaceholder'),
          name: 'code',
          value: code,
          onChange: (e: ChangeEvent<HTMLInputElement>) => {
            setError(false);
            setCode(e.target.value);
          },
          onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => e.key === 'Enter' && validate(),
          type: 'number',
          className: classes.input_noArrows,
        }}
      />
    </>
  );
}

export default withStyles(style)(ValidateTOTPSecretForm);
